// @flow
import { createAction } from 'redux-actions';
import jstz from 'jstimezonedetect';
import moment from 'moment';
import type { Dispatch } from 'redux';
import type { $AxiosError } from 'axios';
import { format } from '../../../../browser/shared/util/gigwalkApiErrorUtil';
import { update as updateTicket } from '../../../redux/entities/tickets';
import * as snackbar from '../../../ducks/snackbar';
import types from './types';

export const submitError = createAction(types.SUBMIT_ERROR);
export const submitSuccess = createAction(types.SUBMIT_SUCCESS);
export const submit = createAction(
    types.SUBMIT,
    (values: Object): Function => (
        (dispatch: Dispatch<any>): Promise<any> => {
            const { scheduleDate, ticketIds } = values;
            const params = {
                action: 'schedule',
                date_scheduled: moment(scheduleDate).format('YYYY-MM-DDTHH:mm:ss'),
                ticket_ids: ticketIds,
                time_zone: jstz.determine().name(),
            };

            return dispatch(updateTicket(params))
                .then((resp: Object) => {
                    dispatch(submitSuccess());
                    if (resp.original && resp.original.gw_api_response && resp.original.gw_api_response.length) {
                        const message = format(resp.data.gw_api_response);
                        dispatch(snackbar.actions.enqueue(message, { variant: 'warning' }));
                    }
                })
                .catch((err: $AxiosError<Object>) => {
                    dispatch(submitError(err));
                    const resp = err ? err.response : null;
                    if (resp && resp.data && resp.data.gw_api_response) {
                        const message = format(resp.data.gw_api_response);
                        dispatch(snackbar.actions.enqueue(message, { variant: 'error' }));
                    }
                    return Promise.reject();
                });
        }
    )
);

export default {
    submit,
    submitError,
    submitSuccess,
};
